import axios, { AxiosPromise } from 'axios';
import { IStorageLocation } from '../../../@types/model/masterData/storageLocation/storageLocation';
import { IStorageLocationUpsert } from '../../../@types/model/masterData/storageLocation/storageLocationUpsert';

export default class StorageLocationHttpService {
    public static getList() : AxiosPromise<Array<IStorageLocation>> {
        return axios.get(`${API_URL}/v1/StorageLocation/GetAllWeb`);
    }

    public static upsert(data : IStorageLocationUpsert) : AxiosPromise<IStorageLocation> {
        return axios.post(`${API_URL}/v1/StorageLocation/upsert`, data);
    }

    public static delete(id : number) : AxiosPromise<IStorageLocation> {
        return axios.delete(`${API_URL}/v1/StorageUnitLocation/Delete`, {
            params : { id },
        });
    }
}